﻿$.fn.dxCtrlCompteEmailGeneral = function custom_dxCtrlCompteEmailGeneral(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcompteemailgeneral dx-ctrl");
        this.createInstance(new cdxCtrlCompteEmailGeneral(this, option));
    }
    return this;
}

window.cdxCtrlCompteEmailGeneral = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.allowSave == 'undefined') option.allowSave = true

    function mConstruit() {
        container.empty();

        if (option.dataCompteEmail.id_utilisateur != option.bddCtrl.utiCourant.id_utilisateur &&
            option.dataCompteEmailUtilisateur.id_utilisateur == option.bddCtrl.utiCourant.id_utilisateur) {
            var objUti = option.bddCtrl.getObjet(option.bddCtrl.mGetArray("utilisateur").filter(function (o) { return o.id_utilisateur == option.dataCompteEmail.id_utilisateur })[0])
            $("<div style='margin:5px'/>").appendTo(container).dxCtrlWarningForm({
                type: "warning",
                html: function () {
                    return "<span class='dxwarningformtext'>Vous êtes abonné à cette adresse email.<br/>Celle-ci est géré par <b>" + objUti.mGetLib1() + "</b>.</span>";
                },
            }).dxCtrlWarningForm("instance")
        }

        var items = [];
        items.push({
            label: { visible: false, text: "login", location: "left" },
            template: function (itemData, itemElement) {
                dxCtrlTxtLogin = $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                    label: "Nom usuel (Nom affiché à vos destinataires dans leur messagerie)",
                    labelMode: 'floating',
                    placeholder: "Saisissez le nom qui sera affiché à vos destinataires...",
                    value: option.dataCompteEmailUtilisateur.nom_usuel,
                    onValueChanged: function (e) {
                        option.dataCompteEmailUtilisateur.nom_usuel = e.value;
                        if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmailUtilisateur).mSaveChamp("nom_usuel")
                    }
                }).dxCtrlTextBox("instance")
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        items.push({
            dataField: "defaut", name: "defaut", label: { visible: false, text: "Défaut", location: "left" },
            template: function (itemData, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlCheckBox({
                    value: (option.dataCompteEmailUtilisateur.defaut == "1"),
                    disabled: (option.dataCompteEmailUtilisateur.defaut == "1"),
                    text: "Adresse email par défaut",
                    labelMode: 'floating',
                    label: "",
                    txtTooltip: "Si vous définissez cette adresse email par défaut,<br/>c'est cette adresse email qui sera utilisée<br/>quand vous commencerez un nouveau message email" + ((option.dataCompteEmailUtilisateur.defaut == "1") ? "<br/><br/><i>Cette adresse email est l'adresse email par défaut.<br/>Pour changer l'adresse email par défaut,<br/>ouvrez la configuration de l'email par défaut et cocher la case.</i>" : ""),
                    onValueChanged: function (e) {
                        option.dataCompteEmailUtilisateur.defaut = ((e.value) ? "1" : "0");
                        if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmailUtilisateur).mSaveChamp("defaut")
                    }
                })
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        items.push({
            label: { visible: false, text: "Nom", location: "left" },
            template: function (itemData, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlCheckBox({
                    value: (option.dataCompteEmailUtilisateur.repondre_avec_email_defaut == "1"),
                    text: "Quand je réponds sur un message reçu sur cette adresse email, répondre avec mon adresse email par défaut.",
                    labelMode: 'floating',
                    label: "",
                    txtTooltip: "Quand vous répondez à un mail,<br/>vous répondez avec l'adresse email sur laquelle on vous a écrit.<br/><br/>Si vous cochez cette case,<br/>vous répondrez alors avec votre adresse email par défaut.",
                    onValueChanged: function (e) {
                        option.dataCompteEmailUtilisateur.repondre_avec_email_defaut = ((e.value) ? "1" : "0");
                        if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmailUtilisateur).mSaveChamp("repondre_avec_email_defaut")
                    }
                })
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        if (option.allowConfidentiel) {
            items.push({
                label: { visible: false, text: "conf", location: "left" },
                visible: option.dataCompteEmail.id_utilisateur==option.bddCtrl.utiCourant.id_utilisateur,
                template: function (itemData, itemElement) {
                    $("<hr style='opacity:0.3'/>").appendTo(itemElement)
                    var $Table = $("<table/>").appendTo(itemElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:1px;text-align:center;'>Confidentialité</td>").appendTo($Tr)
                    $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlSwitch({
                        value: (option.dataCompteEmail.confidentiel == "1"),
                        onValueChanged: function (e) {
                            option.dataCompteEmail.confidentiel = ((e.value) ? "1" : "0")
                            if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("confidentiel")
                            mRempliConfidentiel()
                        }
                    })
                    var $TdDetailConfidentiel = $("<td style='width:100%;padding-left:15px;'/>").appendTo($Tr)
                    mRempliConfidentiel()

                    function mRempliConfidentiel() {
                        var txt = ""
                        if (option.dataCompteEmail.confidentiel == null || option.dataCompteEmail.confidentiel == "0") {
                            txt = "<b style='opacity:0.5;'>Adresse email publique</b><br/>" +
                                "<div style='font-size:70%;opacity:0.5;'>Tous les messages reçus et envoyés sur cette adresse email sont publiques dans " + parametre.nom + ". " +
                                "Ils sont visible aux autres utilisateurs dans l'activité des contacts.</div>"
                        } else {
                            txt = "<b style='opacity:0.5;'>Adresse email confidentiel</b><br/>" +
                                "<div style='font-size:70%;opacity:0.5;'>Vos messages ne sont pas accessibles aux autres utilisateurs. " +
                                "Tous les vues et les clicks fait via cette adresse email sont comptabilisé dans les statistiques des contacts mais invisible dans leur activité pour les autres utilisateurs</div>"
                        }
                        $TdDetailConfidentiel.html(txt)
                    }

                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            })
        }
        if (option.allowSignature) {
            items.push({
                label: { visible: false, text: "Nom", location: "left" },
                template: function (itemData, itemElement) {
                    $("<hr style='opacity:0.3'/>").appendTo(itemElement)
                    var $Div = $("<div/>").appendTo(itemElement)
                    $("<div/>").appendTo($Div).dxCtrlSignatureEmail({
                        bddCtrl:option.bddCtrl,
                        data: option.dataCompteEmailUtilisateur,
                        txtTooltip: "Signature de votre adresse email",
                        titlePopupEmail: "Signature adresse email",
                        onValueChanged: function (dataSignature) {
                            if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmailUtilisateur).mSaveChamp("data_signature");
                        }
                    }).dxCtrlSignatureEmail("instance")
                    //$("<div/>").appendTo($Div).dxCtrlEmailData({
                    //    bddCtrl: option.bddCtrl,
                    //    value: option.dataCompteEmailUtilisateur.data_signature,
                    //    txtTooltip: "Signature de votre adresse email",
                    //    tooltipModif: "Modifier la signature",
                    //    tooltipSupp: "Supprimer la signature",
                    //    tooltipNew: "Créer une nouvelle signature",
                    //    titlePopupEmail: "Signature adresse email",
                    //    rempliTxtLib: function (contentElement, value) {
                    //        var txtLib = ""
                    //        if (value == null || value.length == 0) {
                    //            txtLib = "<div style='color:" + theme.toastWarning + ";font-size:16px;'>(aucune signature spécifique pour cette adresse)</div>"
                    //            if (option.bddCtrl.utiCourant.data_signature == null || option.bddCtrl.utiCourant.data_signature.length == 0) {
                    //                txtLib += "<div style='font-size:90%;'>Vous pouvez définir la signature ici uniquement pour ce mail ou dans le profil utilisateur (dans ce cas, la signature s'appliquera à toutes les adresses sans signature).</div>"
                    //            } else {
                    //                txtLib += "<div style='font-size:90%;'>La signature qui sera utilisé est celle qui est défini au niveau de la configuration utilisateur (dans le profil utilisateur).</div>"
                    //            }
                    //        } else {
                    //            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>Signature spécifique active pour cette adresse</div>"
                    //            txtLib += "<div style='font-size:90%;'>Cette signature est spécifique à cette adresse email.</div>"
                    //        }
                    //        contentElement.html(txtLib)
                    //    },
                    //    onValueChanged: function (dataSignature) {
                    //        option.dataCompteEmailUtilisateur.data_signature = dataSignature;
                    //        if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmailUtilisateur).mSaveChamp("data_signature");
                    //    }
                    //}).dxCtrlEmailData("instance")
                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            })
        }
        if (option.allowRepAuto) {
            items.push({
                label: { visible: false, text: "Nom", location: "left" },
                visible: option.dataCompteEmail.id_utilisateur == option.bddCtrl.utiCourant.id_utilisateur,
                template: function (itemData, itemElement) {
                    $("<hr style='opacity:0.3'/>").appendTo(itemElement)
                    var $Table = $("<table/>").appendTo(itemElement)
                    var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
                    var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding-right:5px;' class='dx-field-item-label-text'>Réponse<br/>automatique:&nbsp;</td>").appendTo($Tr)
                    var $Td = $("<td style='width:100%' colspan='2'></td>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlDefineRepAuto({
                        bddCtrl: option.bddCtrl,
                        data: option.dataCompteEmail
                    })
                    $Tr.attr("title", "Réponse automatique de l'adresse email<br/>Si la réponse automatique est définie sur le compte email<br/>une réponse automatique sera généré<br/>sur les emails reçus dans la période définie.")
                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            })

        }
        if (option.allowPartage) {
            items.push({
                label: { visible: false, text: "Partage", location: "left" },
                visible: option.dataCompteEmail.id_utilisateur == option.bddCtrl.utiCourant.id_utilisateur,
                template: function (itemData, itemElement) {
                    $("<hr style='opacity:0.3'/>").appendTo(itemElement)
                    var $Table = $("<table/>").appendTo(itemElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%'>Abonnement utilisateur à l'adresse email</td>").appendTo($Tr)
                    $Td.attr("title", "Liste les utilisateurs abonné à cette adresse email.<br/>Vous pouvez en rajouter ou en retirer.")
                    var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                    var lstIdUti = []
                    option.bddCtrl.mGetArray("compte_email_utilisateur").filter(function (o) {
                        return o.id_compte_email == option.dataCompteEmail.id_compte_email && o.id_utilisateur != option.dataCompteEmail.id_utilisateur
                    }).forEach(function (cptEmaUti) {
                        lstIdUti.push(cptEmaUti.id_utilisateur)
                    })
                    var dxUtiCre = $("<div style=''/>").appendTo($Td).dxCtrlTagUti({
                        bddCtrl: option.bddCtrl,
                        dataSource: option.bddCtrl.mGetArray("utilisateur").filter(function (o) {
                            return o.id_utilisateur >= 100000 && o.id_utilisateur != option.dataCompteEmail.id_utilisateur
                        }),
                        unitaire: false,
                        placeholder: "",
                        showRobot:false,
                        value: lstIdUti,
                        onDelete: function (idUti) {
                            var cptEmaUti = option.bddCtrl.mGetArray("compte_email_utilisateur").filter(function (o) {
                                return o.id_compte_email == option.dataCompteEmail.id_compte_email && o.id_utilisateur == idUti
                            })[0]
                            option.bddCtrl.getObjet(cptEmaUti).mDelDataDefinitif()
                        },
                        onAdd: function (idUti) {
                            var cptEmaUti = option.bddCtrl.getObjet("compte_email_utilisateur").mGetNewData()
                            cptEmaUti.id_utilisateur = idUti
                            cptEmaUti.id_compte_email = option.dataCompteEmail.id_compte_email
                            option.bddCtrl.getObjet(cptEmaUti).mSave()
                        },
                        onContentReady: function (e) {
                            e.component.element().find(".dx-placeholder").css("font-family", "barlow condensed")
                        }
                    }).dxCtrlTagUti("instance");
                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            })

        }

        //items.push({
        //    label: { visible: false, text: "Test", location: "left" },
        //    template: function (itemData, itemElement) {
        //        $("<div/>").appendTo(itemElement).dxCtrlCompteEmailTestDelivrabilite({
        //            bddCtrl: option.bddCtrl,
        //            dataCompteEmail: option.bddCtrl.getObjet("compte_email", option.dataCompteEmailUtilisateur.id_compte_email).data
        //        })
        //    },
        //    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        //})
        var form = $("<div/>").appendTo(container).dxCtrlForm({
            labelMode: 'floating',
            showColonAfterLabel: true,
            labelLocation: 'left',
            items: items
        }).dxCtrlForm("instance");

    }

    this.mSave = function () {
        option.bddCtrl.getObjet(option.dataCompteEmailUtilisateur).mSave()
    }

    this.element = function () { return container }

    mConstruit();
}